import { SVGProps } from 'react';

const AuthIcons: { [provider: string]: [icon: SVGProps<SVGSVGElement>] } = {
  discord: [
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 50 50"
        height="50"
        width="50"
      >
        <circle cx="25" cy="25" r="25" fill="#5865F2"></circle>
        <path
          fill="white"
          d="M33.8905 16.885C32.1726 16.0841 30.3126 15.5029 28.3751 15.1671C28.3581 15.1665 28.3412 15.1697 28.3256 15.1764C28.3099 15.1831 28.296 15.1931 28.2847 15.2058C28.0522 15.6321 27.7809 16.1875 27.6001 16.6137C25.545 16.3037 23.4551 16.3037 21.4001 16.6137C21.2192 16.1746 20.948 15.6321 20.7026 15.2058C20.6897 15.18 20.6509 15.1671 20.6122 15.1671C18.6747 15.5029 16.8276 16.0841 15.0967 16.885C15.0838 16.885 15.0709 16.8979 15.058 16.9108C11.5447 22.1679 10.5759 27.2829 11.0538 32.3462C11.0538 32.372 11.0667 32.3979 11.0926 32.4108C13.4176 34.1158 15.6522 35.1491 17.8609 35.8337C17.8997 35.8466 17.9384 35.8337 17.9513 35.8079C18.468 35.0975 18.933 34.3483 19.3334 33.5604C19.3592 33.5087 19.3334 33.4571 19.2817 33.4441C18.5455 33.16 17.848 32.8241 17.1634 32.4366C17.1117 32.4108 17.1117 32.3333 17.1505 32.2946C17.2926 32.1912 17.4347 32.075 17.5767 31.9716C17.6026 31.9458 17.6413 31.9458 17.6672 31.9587C22.1105 33.9866 26.9026 33.9866 31.2942 31.9587C31.3201 31.9458 31.3588 31.9458 31.3847 31.9716C31.5267 32.0879 31.6688 32.1912 31.8109 32.3075C31.8626 32.3462 31.8626 32.4237 31.798 32.4495C31.1263 32.85 30.4159 33.1729 29.6797 33.4571C29.628 33.47 29.6151 33.5346 29.628 33.5733C30.0413 34.3612 30.5063 35.1104 31.0101 35.8208C31.0488 35.8337 31.0876 35.8466 31.1263 35.8337C33.348 35.1491 35.5826 34.1158 37.9076 32.4108C37.9334 32.3979 37.9463 32.372 37.9463 32.3462C38.5147 26.495 37.0034 21.4187 33.9422 16.9108C33.9292 16.8979 33.9163 16.885 33.8905 16.885ZM20.0051 29.2591C18.6747 29.2591 17.5638 28.0321 17.5638 26.5208C17.5638 25.0096 18.6488 23.7825 20.0051 23.7825C21.3742 23.7825 22.4592 25.0225 22.4463 26.5208C22.4463 28.0321 21.3613 29.2591 20.0051 29.2591ZM29.008 29.2591C27.6776 29.2591 26.5667 28.0321 26.5667 26.5208C26.5667 25.0096 27.6517 23.7825 29.008 23.7825C30.3772 23.7825 31.4622 25.0225 31.4492 26.5208C31.4492 28.0321 30.3772 29.2591 29.008 29.2591Z"
        />
      </svg>
    </>,
  ],
  google: [
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
      >
        <circle cx="25" cy="25" r="24.5" fill="white" stroke="#CECECE" />
        <path
          d="M34.8055 23.0415H34V23H25V27H30.6515C29.827 29.3285 27.6115 31 25 31C21.6865 31 19 28.3135 19 25C19 21.6865 21.6865 19 25 19C26.5295 19 27.921 19.577 28.9805 20.5195L31.809 17.691C30.023 16.0265 27.634 15 25 15C19.4775 15 15 19.4775 15 25C15 30.5225 19.4775 35 25 35C30.5225 35 35 30.5225 35 25C35 24.3295 34.931 23.675 34.8055 23.0415Z"
          fill="#FFC107"
        />
        <path
          d="M16.1531 20.3455L19.4386 22.755C20.3276 20.554 22.4806 19 25.0001 19C26.5296 19 27.9211 19.577 28.9806 20.5195L31.8091 17.691C30.0231 16.0265 27.6341 15 25.0001 15C21.1591 15 17.8281 17.1685 16.1531 20.3455Z"
          fill="#FF3D00"
        />
        <path
          d="M24.9999 35.0003C27.5829 35.0003 29.9299 34.0118 31.7044 32.4043L28.6094 29.7853C27.5717 30.5745 26.3036 31.0014 24.9999 31.0003C22.3989 31.0003 20.1904 29.3418 19.3584 27.0273L16.0974 29.5398C17.7524 32.7783 21.1134 35.0003 24.9999 35.0003Z"
          fill="#4CAF50"
        />
        <path
          d="M34.8055 23.0415H34V23H25V27H30.6515C30.2571 28.1082 29.5467 29.0766 28.608 29.7855L28.6095 29.7845L31.7045 32.4035C31.4855 32.6025 35 30 35 25C35 24.3295 34.931 23.675 34.8055 23.0415Z"
          fill="#1976D2"
        />
      </svg>
    </>,
  ],
  facebook: [
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="51"
        viewBox="0 0 50 51"
        fill="none"
      >
        <circle cx="25" cy="25" r="25" fill="#1778F2" />
        <g clipPath="url(#clip0_595_4927)">
          <path
            d="M20.8503 51V33.1693H16V26.7494H20.8503V21.2659C20.8503 16.957 23.7153 13 30.3171 13C32.99 13 34.9665 13.2491 34.9665 13.2491L34.8108 19.2442C34.8108 19.2442 32.795 19.2251 30.5954 19.2251C28.2147 19.2251 27.8333 20.2916 27.8333 22.0617V26.7494H35L34.6882 33.1693H27.8333V51H20.8503Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_595_4927">
            <rect width="19" height="38" fill="white" transform="translate(16 13)" />
          </clipPath>
        </defs>
      </svg>
    </>,
  ],
};

export default AuthIcons;
